import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// import Link from 'shared/components/Link/Link';

import myavto from 'shared/assets/images/articles/leasing/partner-myavto.png';
import mycredit from 'shared/assets/images/articles/leasing/partner-mycredit.png';
import otpbank from 'shared/assets/images/articles/leasing/partner-otpbank.png';

import s from './LeasingPartners.css';

class LeasingPartners extends React.Component {
  static defaultProps = {};
  render() {
    return (
      <div className={s.root}>
        <a href={null}>
          <img src={mycredit} alt="" />
        </a>
        <a href={null}>
          <img src={otpbank} alt="" />
        </a>
        <a target="_blank" href="https://myavto.com.ua/">
          <img src={myavto} alt="https://myavto.com.ua/" />
        </a>
      </div>
    );
  }
}

export default withStyles(s)(LeasingPartners);



// WEBPACK FOOTER //
// ./src/shared/components/Article/Leasing/LeasingPartners/LeasingPartners.js